import { Choice } from '@cmsgov/ds-medicare-gov';
import * as PropTypes from 'prop-types';
import React from 'react';
import '../css/checkbox.css';
import cloneObject from '../functions/clone.object';
import the from '../objects/the';

const Checkbox = props => {
   const clonedProps = cloneObject(props);
   delete clonedProps.errorMessage;
   return <>
      <div>
         <Choice
            labelClassName={props.errorMessage ? 'error' : ''}
            {...clonedProps}
         >
            {props.title}
         </Choice>
         {props.children}
         <div style={{
            color: the.color.darkRed,
            display: props.errorMessage ? 'block' : 'none',
            fontFamily: 'Rubik',
            fontSize: 14,
         }}>
            {props.errorMessage}
         </div>
      </div>
   </>
}

Checkbox.propTypes = {
   errorMessage: PropTypes.string,
};

Checkbox.defaultProps = {
   errorMessage: null,
};

export default Checkbox;